var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckGreenWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-702.831 -3690.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    transform: "translate(702.831 3690.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.577,14.021l-1.655-1.7a.356.356,0,0,0-.263-.113h0a.341.341,0,0,0-.263.113L16.923,23.876,12.748,19.7a.364.364,0,0,0-.527,0l-1.674,1.674a.375.375,0,0,0,0,.536l5.266,5.266a1.665,1.665,0,0,0,1.1.536A1.745,1.745,0,0,0,18,27.2h.009L30.587,14.557A.4.4,0,0,0,30.577,14.021Z",
    transform: "translate(708.751 3697.31)",
    fill: "#1c9d87"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreenWhite);
export default __webpack_public_path__ + "static/media/Icon-check-green-white.b3e6891439c01e5cf23a1c13cb214de6.svg";
export { ForwardRef as ReactComponent };